import React from 'react';
import { BookPage } from './pages/BookPage';
export function App() {
  return <BookPage data-id="element-0" />;
}